import { appHttpClient } from "../../installations/http/axiosInterfaces";
import { dedupeRequest } from "../../installations/http/inFlight";
import qs from "qs";

export const addProduct = (data) => {
  return appHttpClient.post(`/Product/Add`, data);
};

export const updateProduct = (data) => {
  return appHttpClient.post(`/Product/Update`, data);
};

export const deleteProduct = (productId) => {
  return appHttpClient.delete(`/Product/Delete/${productId}`);
};

export const getProductById = (productId) => {
  // 0016: dedupe StrictMode double-invoke; key on the item id so different items fetch independently.
  // NOTE: getItems (/Item/List) is intentionally NOT wrapped — it is already RQ-deduped via usePagination.
  return dedupeRequest(`item:${productId}`, () =>
    appHttpClient.get(`/Item/${productId}`)
  );
};

// export const getItems = (queryParams) => {
//   return appHttpClient.get(`/Item/List`, { params: queryParams });
// };

export const getItems = (queryParams) => {
  return appHttpClient.get(`/Item/List`, {
    params: queryParams,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const addProductImage = (productId, file, isPrimary) => {
  const formData = new FormData();
  formData.append("file", file);
  return appHttpClient.post(`/Product/Update/Image/${productId}/${isPrimary}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Inform the server that this is form data
    },
  });
};

export const deleteProductImage = (productId, imageId) => {
  return appHttpClient.delete(`/Product/Delete/Image/${productId}/${imageId}`);
};

export const setImageAsPrimary = (productId, imageId) => {
  return appHttpClient.delete(`/Product/Update/Image/Primary/Set/${productId}/${imageId}`);
};

export const updateItemExtension = (itemId, data) => {
  return appHttpClient.post(`/Item/Extensions/Update/${itemId}`, data);
};

export const updateItemAttributesExtension = (itemId, itemAttributes) => {
  return appHttpClient.post(`/Item/Extensions/Update/Attributes/${itemId}`, itemAttributes);
};

export const updateItemRelatedItemsExtension = (itemId, relatedItems) => {
  return appHttpClient.post(`/Item/Extensions/Update/RelatedItems/${itemId}`, relatedItems);
};

const productService = {
  addProduct,
  updateProduct,
  deleteProduct,
  getProductById,
  getItems,
  addProductImage,
  deleteProductImage,
  setImageAsPrimary,
  updateItemExtension,
  updateItemAttributesExtension,
  updateItemRelatedItemsExtension,
};

export default productService;
